export const IMPORT_TYPE = {
  individuals: 1,
  pedigrees: 2,
};

export const START_AT_ROW = {
  no: 1,
  yes: 2,
};

export const FILE_DELIMITER = {
  txtTab: '\t',
  txtComma: ',',
  txtOther: 'other',
};

export const INDIVIDUALS_BLANK_SETTING = {
  importBlanks: 1,
  dontImportBlanks: 0,
};

export const COLUMN_TYPES = {
  pedigreeName: 'PEDIGREE_NAME',
  individualName: 'INDIVIDUAL_NAME',
  fatherId: 'FATHER_ID',
  motherId: 'MOTHER_ID',
  sex: 'SEX',
  child: 'CHILD',
  sibling: 'SIBLING',
  spouse1: 'SPOUSE_1',
  spouse2: 'SPOUSE_2',
  twinStatus: 'TWIN_STATUS',
  twinRelationship: 'TWIN_RELATIONSHIP',
  probandStatus: 'PROBAND_STATUS',
  deceased: 'DECEASED',
};